import { notifications } from '@mantine/notifications';

export const openNotification = (
  type: 'success' | 'danger' | 'warning',
  title = 'Title',
  message: any = 'Message'
) => {
  let safeMessage = message;
  if (typeof message === 'object' && message !== null) {
    if (message?.data?.message) {
      safeMessage = message.data.message;
    } else if (message?.data?.Messages?.length) {
      safeMessage = message.data.Messages[0];
    } else if (message?.message) {
      safeMessage = message.message;
    } else {
      safeMessage = 'An error occurred. Please try again.';
    }
  }

  notifications.show({
    title,
    message: safeMessage,
    autoClose: 7000,
    classNames: {
      root: `notification-root ${type}`,
      title: 'notification-title',
      description: 'notification-description',
    },
  });
};
